import { IPlayerState } from '../reducer.types';
import { trackProgress } from '../actions';

export const trackProgressReducer = (
  state: IPlayerState,
  action: ReturnType<typeof trackProgress>,
) => {
  return {
    ...state,
    durationPlayedInPermille: Math.round(action.payload.durationPlayedInPermille),
    durationPlayedInSeconds: Math.round(action.payload.durationPlayedInSeconds),
  };
};
